// extracted by mini-css-extract-plugin
export default {"item_list":"FormatColumn_item_list__SYpsn","myHandle":"FormatColumn_myHandle__VW0Db","hide-li":"FormatColumn_hide-li__Dho2h"};